import React, { useState } from 'react';
import { Box, IconButton, Chip, Popover, Typography } from '@mui/material';
import AddReactionIcon from '@mui/icons-material/AddReaction';
import axiosInstance from '../../axiosInstance';

const COMMON_EMOJIS = ['👍', '❤️', '😂', '😮', '😢', '🎉', '🔥', '👏'];

export default function ActivityReactions({ activityId, reactions = [], currentUserId, onReactionChange }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleOpenPicker = (event) => setAnchorEl(event.currentTarget);
  const handleClosePicker = () => setAnchorEl(null);

  const handleReactionClick = async (emoji) => {
    if (loading) return;
    const userReacted = reactions.some(
      r => r.emoji === emoji && String(r.userId?._id || r.userId) === String(currentUserId)
    );
    setLoading(true);
    try {
      let res;
      if (userReacted) {
        res = await axiosInstance.delete(`/activity/${activityId}/react`, { data: { emoji } });
      } else {
        res = await axiosInstance.post(`/activity/${activityId}/react`, { emoji });
        handleClosePicker();
      }
      onReactionChange(res.data.reactions);
    } catch (err) {
      console.error('Reaction error:', err);
    } finally {
      setLoading(false);
    }
  };

  const grouped = reactions.reduce((acc, r) => {
    if (!acc[r.emoji]) acc[r.emoji] = { count: 0, users: [], userReacted: false };
    acc[r.emoji].count++;
    acc[r.emoji].users.push(r.userId?.username || 'Someone');
    if (String(r.userId?._id || r.userId) === String(currentUserId)) acc[r.emoji].userReacted = true;
    return acc;
  }, {});

  const open = Boolean(anchorEl);

  return (
    <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center', flexWrap: 'wrap' }}>
      {Object.entries(grouped).map(([emoji, data]) => (
        <Chip
          key={emoji}
          label={`${emoji} ${data.count}`}
          size="small"
          onClick={() => handleReactionClick(emoji)}
          color={data.userReacted ? 'primary' : 'default'}
          variant={data.userReacted ? 'filled' : 'outlined'}
          title={data.users.join(', ')}
          sx={{ cursor: 'pointer' }}
        />
      ))}
      <IconButton size="small" onClick={handleOpenPicker} disabled={loading} sx={{ p: 0.5 }}>
        <AddReactionIcon fontSize="small" />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClosePicker}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Box sx={{ p: 1.5, display: 'flex', gap: 0.5, flexWrap: 'wrap', maxWidth: 240 }}>
          <Typography variant="caption" sx={{ width: '100%', mb: 0.5 }}>React:</Typography>
          {COMMON_EMOJIS.map(emoji => (
            <IconButton key={emoji} size="small" onClick={() => handleReactionClick(emoji)}
              sx={{ fontSize: '1.25rem' }}>
              {emoji}
            </IconButton>
          ))}
        </Box>
      </Popover>
    </Box>
  );
}
